var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`icon-button ${_vm.size}`,attrs:{"aria-label":_vm.ariaLabel},on:{"click":_vm.handleClick}},[_c('font-awesome-icon',{attrs:{"icon":[`${_vm.iconStyle}`, `${_vm.iconName}`]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }